import type { ExclusiveGroupCoverage } from '@/features/quotes/types/group-life/coverage-schema.types';
import type { CoverageSelection } from '@/features/quotes/utils/group-life/coverage-resolver';
import { CoverageRowShell } from './coverage-row-shell';

type Props = {
  coverage: ExclusiveGroupCoverage;
  selection: CoverageSelection | undefined;
  onChange: (next: CoverageSelection) => void;
  disabled?: boolean;
  error?: string;
};

export function ExclusiveGroupRow({
  coverage,
  selection,
  onChange,
  disabled,
  error,
}: Props) {
  const enabled =
    selection?.kind === 'EXCLUSIVE_GROUP' ? selection.enabled : false;

  return (
    <CoverageRowShell
      name={coverage.name}
      description={coverage.description}
      badge={coverage.isRider ? 'Adicional' : undefined}
      caption={`Grupo exclusivo: ${coverage.exclusionGroupCode}`}
      enabled={enabled}
      onToggle={next => onChange({ kind: 'EXCLUSIVE_GROUP', enabled: next })}
      disabled={disabled}
      error={error}
    />
  );
}
